<template>
    <div id="configurator-wrapper" v-if="showConfigurator">
      <Header />
      <ContentBlock />
      <FAQ />
    </div>
</template>

<script>
import Header from "./station-components/Header.vue";
import FAQ from './station-components/FAQ.vue';
import ContentBlock from './station-components/ContentBlock.vue';

import { collectUtmParameters, currentPath } from "./services/helpers";

export default {
  name: "BaseStation",
  components: {
    Header,
    FAQ,
    // Helpbox,
    ContentBlock
  },
  computed: {
    showConfigurator: function() {
      const show =
        (currentPath()["id"] === undefined || currentPath()["id"] === null) && (currentPath()["verkaufId"] === undefined || currentPath()["verkaufId"] === null);
      return show;
    },
    showSummary: function() {
      return currentPath()["id"];
    },
    showVerkauf: function() {
      return currentPath()["verkaufId"];
    }
  },
  methods: {
    // removeLinkCanonical () {
    //   const canonicalLink = document.querySelector('link[rel="canonical"]');      

    //   if (canonicalLink) {
    //    canonicalLink.href = 'https://www.pkw.de/auto-verkaufen/auto-bewerten/';
    //   }
    // },
    // updateTitle() {
    //   document.title = "Auto bewerten online - Was ist mein Auto wert?";
    // },
    // updateMetaDescription () {
    //   const _desc = "Kostenlos deinen Fahrzeugwert ermitteln ✅ Restwert deines Gebrauchtwagen berechnen ✅ ohne Registrierung in 1 Minute per E-Mail";
    //   document.querySelector('meta[name="description"]').setAttribute("content", _desc);
    // }
    // facebookPixelInit() {
    //   let n, t, s;
    //   if (window.fbq) return;
    //   n = window.fbq = function() {
    //     n.callMethod
    //       ? n.callMethod.apply(n, arguments)
    //       : n.queue.push(arguments);
    //   };
    //   if (!window._fbq) {
    //     window._fbq = n;
    //     n.push = n;
    //     n.loaded = !0;
    //     n.version = "2.0";
    //   }
    //   n.queue = [];
    //   t = document.createElement("script");
    //   t.async = !0;
    //   t.src = "https://connect.facebook.net/en_US/fbevents.js";
    //   s = document.getElementsByTagName("script")[0];
    //   s.parentNode.insertBefore(t, s);
    //   window.fbq("init", "551810986050048");
    //   window.fbq("track", "PageView");
    // }
    getUtmParams() {
      const UTM_PARAMS = collectUtmParameters();
      for (const key in UTM_PARAMS) {
        this.$cookies.set(key, UTM_PARAMS[key]);
      }
    }
  },
  mounted: function() {
    //this.removeLinkCanonical();

    //this.updateTitle();
    //this.updateMetaDescription();

    // this.facebookPixelInit();
    this.getUtmParams();
    let contentEl = document.getElementById("content");
    let headerEl = document.getElementById("header");
    let footerEl = document.getElementById("footer");
    let app = document.getElementById("app");
    if (this.showConfigurator) {
      contentEl.style.display = "block";
      headerEl.style.display = "block";
      footerEl.style.display = "block";
    }
    if (this.showSummary) {
      headerEl.style.display = "block";
      footerEl.style.display = "block";
    }
    if (this.showVerkauf) {
      app.style.height = "initial";
      app.style.width = "100%";
    }

    if(window.location.search.trim() !== '') {
      const params = new URLSearchParams(window.location.search);
      for (const param of params.entries()) {
        this.$store.dispatch("selectOption", {
          name: param[0],
          value: +param[1]
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/vars";
@import "~@/assets/flexboxgrid";
@import "~@/assets/static-content-landing";

html,
body,
#verkauf-wrapper,
#verkauf-wrapper .verkauf {
  width: 100%;
  height: 100%;
  color: #010101;
}


@media print {
  .main-footer {
    display:none;
  }
  .main-header {
    display:none;
  }
}


.top-content-wrap *,
.top-content-wrap *:before,
.top-content-wrap *:after {
  // position: initial;
  box-sizing: border-box;
}
.bordered-heading {
  position: relative;
  padding-left: 13px;

  &:before {
    content: "";
    display: block;
    width: 3px;
    background: #c0141b;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
  }
}

#content {
  @include breakpoint(frommediumlarge) {
      padding: 20px 0;
  }
  .wrapper {
    max-width: 1240px;
    margin: 0 auto;
    height: 100%;
    padding: 40px 15px;
    
    h2 {
      font-size: 24px;
      font-weight: 700;
      font-style: normal;
      letter-spacing: normal;
      line-height: normal;
      text-align: left;
      color: #1a1919;
      @include breakpoint(frommediumlarge) {
        font-size: 50px;
      }
    }
    h3 {
      font-size: 20px;
      font-weight: 700;
      font-style: normal;
      letter-spacing: normal;
      line-height: 30px;
      text-align: left;
      color: #1a1919;
      margin-bottom:20px;
      @include breakpoint(frommediumlarge) {
        font-size: 30px;
        line-height: 40px;
      }
    }
    p {
      color: #1a1919;
      margin-bottom: 20px;
      @include breakpoint(frommediumlarge) {
        line-height: 26px;
      }
      
    }
    &.info-block-1 {
      @include breakpoint(frommediumlarge) {
        display: flex;
      }
      .column-1 {
        @include breakpoint(frommediumlarge) {
          width: 50%;
        }
      }
      .column-2 {
        margin: 0 -15px;
        display: flex;
        justify-content: end;
        img {
          margin-top:20px;
          width: 100%;
        }
        @include breakpoint(frommediumlarge) {
          width: 50%;
          margin: 0;
          padding-left:70px;
          img {
            width: 100%;
            margin-top:85px;
            object-fit: contain;
          }
        }
      }
    }
    &.info-block-2 {
      margin-top: -150px;
      margin-bottom: 0;
      padding-bottom: 0;
      @include breakpoint(frommediumlarge) {
        margin-top: 0px;
        display: flex;
      }
      .column-1 {
        padding:0 5px;
        margin-bottom:20px;
        @include breakpoint(frommediumlarge) {
          width: 32%;
        }
        @include breakpoint(mediumlarge) {
          width: 40%;
        }
        
        .car-card {
          box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.1);
          border-radius: 30px;
          background-color: #f2f2f2;
          border: 8px solid #ffffff;
          padding: 35px 20px;
          position: relative;
        
          @include breakpoint(frommediumlarge) {
            max-width: 280px;
          }
          .car-card-image {
            margin-bottom:10px;
          }
          .car-card-title {
            color: #3a3a3a;
            font-size: 20px;
            font-weight: 700;
            font-style: normal;
            letter-spacing: normal;
            line-height: 24px;
            text-align: center;
            margin-bottom:20px;
          }
          .car-card-price {
            color: $green;
            font-size: 38px;
            font-weight: 700;
            font-style: normal;
            letter-spacing: normal;
            line-height: 50px;
            text-align: center;
            border-bottom: 1px solid #dadada;
            padding-bottom:40px;
            margin-bottom: 55px;
          }
          .car-card-button {
            pointer-events: none;
            border-radius: 25px;
            background-color: $white;
            border: 1px solid $green;
            color: $green;
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover {
              background-color: lighten($green, 5%);
            } 
          }
        }
      }
      .column-2 {
        @include breakpoint(fromlarge) {
          width: 68%;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        @include breakpoint(mediumlarge) {
          width: 60%;
        }
        h3 {
          margin-bottom: 40px;
        }
      }
    }
    &.info-block-3 {
       @include breakpoint(frommediumlarge) {
        display: flex;
        flex-wrap: wrap;
        h3 {
          flex: 0 0 100%;
          text-align: center;
          margin: 20px 0 60px;
        }
        .column-1 {
          width: 50%;
          padding-right: 25px;
        }
        .column-2 {
          padding-left: 25px;
          width: 50%;
        }
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/BaseStation.vue